import { combineReducers } from 'redux'
import auth from './slices/auth/authSlice'
import booking from './slices/booking/bookingSlice'
import connector from './slices/connector/connectorSlice'
import dashboard from './slices/dashboard/dashboardSlice'
import device from './slices/device/deviceSlice'
import driverDetail from './slices/driver/driverDetailSlice'
import driver from './slices/driver/driverSlice'
import group from './slices/group/groupSlice'
import instruction from './slices/instructions/instructionSlice'
import logs from './slices/logs/logSlice'
import maintenance from './slices/maintenance/maintenanceSlice'
import operator from './slices/operator/operatorSlice'
import warrantyPackage from './slices/packageSlice/packageSlice'
import remoteTrigger from './slices/remoteTrigger/remoteTriggerSlice'
import smartCharging from './slices/smartCharging/smartChargingSlice'
import tariff from './slices/tariff/tariffSlice'
import theme from './slices/theme/themeSlice'
import transaction from './slices/transaction/transactionSlice'
import troubleshooting from './slices/troubleshooting/troubleshootingSlice'
import user from './slices/user/userSlice'

const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        theme,
        auth,
        dashboard,
        device,
        connector,
        operator,
        user,
        driver,
        driverDetail,
        tariff,
        booking,
        remoteTrigger,
        logs,
        transaction,
        smartCharging,
        maintenance,
        warrantyPackage,
        troubleshooting,
        instruction,
        group,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}

export default rootReducer
